import { useEffect, useRef } from "react";
import { getLenis } from "@/hooks/useSmoothScroll";

/**
 * Fixed drafting-grid backdrop. Extremely thin square grid with tiny circular
 * nodes at intersections. Subtle vertical drift on scroll (updated via ref to
 * avoid re-renders) gives the sense of construction guides sliding beneath the
 * content. Never overpowers.
 */
export default function DraftingGrid() {
  const patternRef = useRef(null);

  useEffect(() => {
    let raf;
    const tick = () => {
      const lenis = getLenis();
      if (lenis && patternRef.current) {
        const drift = (lenis.scroll * 0.05) % 88;
        patternRef.current.setAttribute("patternTransform", `translate(0 ${drift})`);
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-0" aria-hidden>
      <svg width="100%" height="100%" className="absolute inset-0">
        <defs>
          <pattern
            ref={patternRef}
            id="ama-grid"
            width="88"
            height="88"
            patternUnits="userSpaceOnUse"
          >
            <path d="M 88 0 L 0 0 0 88" fill="none" stroke="#ededeb" strokeWidth="1" />
            <circle cx="0" cy="0" r="1.1" fill="#d4d4cf" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#ama-grid)" />
      </svg>
      {/* emphasised vertical construction columns */}
      <div className="absolute inset-0 mx-auto grid h-full max-w-[1600px] grid-cols-4 px-6 md:px-12">
        <div className="border-l border-[#f1f1ee]" />
        <div className="border-l border-[#f1f1ee]" />
        <div className="border-l border-[#f1f1ee]" />
        <div className="border-l border-r border-[#f1f1ee]" />
      </div>
    </div>
  );
}
